<p-menu
  appendTo="body"
  [popup]="true">
  <ng-template
    let-item
    pTemplate
    type="itemTemplate">
    @if (castItem(item); as item) {
      <a
        class="flex size-full cursor-pointer select-none items-center gap-2 p-2"
        [class.bg-surface-accent-active]="item.state?.['active']"
        [attr.href]="item.url"
        [ngClass]="{
          'border-b': !!item?.['showDivider']
        }">
        @if (item['icon']; as icon) {
          <svg-icon
            size="lg"
            class="w-4 shrink-0 opacity-60"
            [class.text-green-500]="icon === 'check-circle'"
            [key]="castIcon | call: icon" />
        }

        <span
          class="text-sm"
          [class.text-text-accent]="item.state?.['active']">
          {{ item.label }}
        </span>

        @if (item.state?.['active']) {
          <svg-icon
            class="text-text-accent ml-auto"
            key="check" />
        }
      </a>
    }
  </ng-template>
</p-menu>
